import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ForgotComponent } from './shared/forgot/forgot.component';
import { RegisterComponent } from './shared/register/register.component';

import { MyProfileComponent } from './shared/my-profile/my-profile.component';

import { appuser } from './users/appuser.component';
import { LoginComponent } from 'src/authentication/login/login.component';
import { LoginGuard } from 'src/authentication/login/login.guard';
import { AuthGuard } from 'src/authentication/core/auth.guard';

import { ProjectModule } from './project-module/project-module.module';
import { PeopleModule } from './people-module/people-module.module';
import { ProfileModule } from './profile-module/profile-module.module';
import { ShiftListComponent } from './masterClient-module/shiftList/shiftList.component';
import { setPassword } from './setPassword/setPassword.component';
import { termsAndConditionsComponent } from './information/terms-and-conditions/termsAndCondition.component';

const appRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard],
  },
  {
    path: 'setpassword',
    component: setPassword,
    canActivate: [LoginGuard],
  },
  {
    path: 'forgotpassword',
    component: ForgotComponent,
    canActivate: [LoginGuard],
  },
  
  {
    path: 'terms-and-conditions',
    loadChildren: () =>
      import('./information/information.module').then((m) => m.InformationModule),
    canActivate: [],
    data: [],
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AuthGuard],
    data: [],
  },

  {
    path: 'schedule',
    loadChildren: () =>
      import('./schedule-module/schedule.module').then((m) => m.ScheduleModule),
    canActivate: [AuthGuard],
    data: [{permission:"schedulemenu::read"}],
  },

  {
    path: 'project-gantt',
    loadChildren: () =>
      import('./project-gantt-module/project-gantt.module').then(
        (m) => m.ProjectGanttModule
      ),

    canActivate: [AuthGuard],
    data: [{permission:"projectganttmenu::read"}],
  },

  {
    path: 'client',
    loadChildren: () =>
      import('./client-module/client-module.module').then(
        (m) => m.ClientModule
      ),
    canActivate: [AuthGuard],
    data: [{permission:"client::read"}],
  },

  {
    path: 'project',
    loadChildren: () =>
      import('./project-module/project-module.module').then(
        (m) => m.ProjectModule
      ),
    canActivate: [AuthGuard],
    data: [{permission:"projectmenu::read"}],
  },
  {
    path: 'report',
    loadChildren: () =>
      import('./report-module/report.module').then(
        (m) => m.ProjectReportModule
      ),
    canActivate: [AuthGuard],
    data: [{permission:"reportmenu::read"}],
  },

  {
    path: 'tasks',
    loadChildren: () =>
      import('./task-module/task-module.module').then((m) => m.TaskModule),
    canActivate: [AuthGuard],
    data: [{permission:"taskmenu::read"}],
  },

  {
    path: 'resources',
    loadChildren: () =>
      import('./people-module/people-module.module').then(
        (m) => m.PeopleModule
      ),
    canActivate: [AuthGuard],
    data: [{permission:"resourcemenu::read"}],
  },

  {
    path: 'team',
    loadChildren: () =>
      import('./department-module/department-module.module').then(
        (m) => m.DepartmentModule
      ),
    canActivate: [AuthGuard],
    data: [{permission:"teammenu::read"}],
  },

  {
    path: 'designation',
    loadChildren: () =>
      import('./designation-module/designation-module.module').then(
        (m) => m.DesignationModule
      ),
    canActivate: [AuthGuard],
    data: [{permission:"designationmenu::read"}],
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./profile-module/profile-module.module').then(
        (m) => m.ProfileModule
      ),
    canActivate: [AuthGuard],
    data: [{permission:"profilemenu::read"}],
  },
  {
    path: 'manage',
    loadChildren: () =>
      import('./application-management/application-management.module').then(
        (m) => m.ApplicationManagementModule
      ),
    canActivate: [AuthGuard],
    data: [{permission:"adminmenu::read"}],
  },
  {
    path: 'masterclient',
    loadChildren: () =>
      import('./masterClient-module/masterClient-module.module').then((m) => m.masterClientModule),
    canActivate: [AuthGuard],
    data: [{permission:"masterclient::read"}],
  },
  {
    path: 'Settings',
    loadChildren: () =>
      import('./settings/settings.module').then((m) => m.SettingModule),
    canActivate: [AuthGuard],
    data: [{permission:"settingsmenu::read"}],
  },
  {
    path: 'taskstatus',
    loadChildren: () =>
      import('./taskStatus-module/taskStatus-module.module').then((m) => m.taskStatusModule),
    canActivate: [AuthGuard],
    data: [{permission:"settingsmenu::read"}],
  },
  {
    path: 'signup',
    loadChildren: () =>
      import('./signUp-module/signUp-module.module').then((m) => m.SignUpModule),
    canActivate: [LoginGuard],
    data: [],
  },
  {
    path: '',
    loadChildren: () =>
      import('./schedule-module/schedule.module').then((m) => m.ScheduleModule),
    canActivate: [AuthGuard],
    data: [{permission:"schedulemenu::read"}],
  },

  {
    path: '**',

    loadChildren: () =>
      import('./schedule-module/schedule.module').then((m) => m.ScheduleModule),
    canActivate: [AuthGuard],
    data: [{permission:"schedulemenu::read"}],
  },

  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [],
  },

  // {
  //   path: "",
  //   component: appuser,

  //   canActivate: [AuthGuard],

  //   data: []
  // },

  {
    path: 'home',
    component: appuser,

    canActivate: [AuthGuard],

    data: [],
  },

  {
    path: 'appuser',
    component: appuser,

    canActivate: [AuthGuard],

    data: [],
  },
  

  // {
  //   path: "**",
  //   component: appuser,

  //   canActivate: [AuthGuard],

  //   data: []
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
